import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { Modulo } from '../../../shared/services/models/usuario/modulo.model';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';

import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';

@Component({
  selector: 'app-home',
  imports: [HeaderComponent, RouterModule, MatCardModule, MatRippleModule, ListaFuncionalidadeComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  public listaModulos: Modulo[] = [];
  public nomeUsuario: string = '';

  constructor(private authService: AuthService) {
    this.moduloEnum = ModuloEnum.Home;
    this.funcionalidadeEnum = FuncionalidadeEnum.Home_Home;
  }

  ngOnInit(): void {
    const usuarioLoginResponse = this.authService.getUserInfos();

    if (usuarioLoginResponse && usuarioLoginResponse.listaModulos) {
      this.nomeUsuario = usuarioLoginResponse.nomeUsuario;

      // Popula a lista de módulos para serem exibidos como atalhos
      this.listaModulos = usuarioLoginResponse.listaModulos;
    }
  }
}
